import certificate from "../../assets/course-details/certificate.png";
import li1 from "../../assets/course-details/certi1.svg";
import li2 from "../../assets/course-details/certi2.svg";

const Certificate = ({ data }) => {
  if (!data.section[7].isActive) {
    return <div></div>;
  }

  return (
    <div className="my-12 px-4 sm:px-8 lg:px-[110px] py-12 bg-gradient-to-br from-blue-900 via-primary-color to-blue-800">
      <h1 className="text-center text-white text-2xl sm:text-3xl lg:text-[40px] font-medium">
        Course{" "}
        <span className="text-secondary-color">Completion Certificate</span>
      </h1>
      <div className="mx-auto mt-8 flex flex-col lg:flex-row gap-8 lg:gap-y-16 max-w-[1500px]">
        <ul className="text-[#c9c9c9] sm:text-18 lg:text-24 font-semibold my-auto space-y-10">
          <li>
            <div className="flex items-start gap-4 lg:gap-6">
              <div className="w-12 h-12 rounded-full bg-white/10 flex items-center justify-center flex-shrink-0">
              <img
                src={li1}
                alt=""
                  className="w-6 sm:w-7 lg:w-8"
              />
              </div>
              <p className="text-20 leading-relaxed">
                Upon successful completion, you&apos;ll receive a recognized{" "}
                {data.programName} degree from Chandigarh University.
              </p>
            </div>
          </li>
          <li>
            <div className="flex items-start gap-4 lg:gap-6">
              <div className="w-12 h-12 rounded-full bg-white/10 flex items-center justify-center flex-shrink-0">
              <img
                src={li2}
                alt=""
                  className="w-6 sm:w-7 lg:w-8"
              />
              </div>
              <p className="text-20 leading-relaxed">
                Potential for industry-specific certifications through workshops
                or electives.
              </p>
            </div>
          </li>
        </ul>
        <div className="relative">
          <div className="absolute -top-2 -left-2 w-24 h-24 border-t-4 border-l-4 border-secondary-color"></div>
        <img
          src={certificate}
          alt=""
            className="w-full sm:w-[60%] lg:w-auto mx-auto lg:mx-0 relative z-10"
        />
        </div>
      </div>
    </div>
  );
};

export default Certificate;
